import { Link } from 'react-router-dom';
import { APP_DEFAULT_PATH } from 'config';
import LogoMark from 'components/LogoMark';

export const DrawerHeader = () => {
  return (
    <div className="m-header">
      <Link
        to={APP_DEFAULT_PATH}
        className="b-brand"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          width: '100%',
          textDecoration: 'none'
        }}
      >
        <LogoMark size={28} />
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'baseline',
            fontWeight: 800,
            letterSpacing: '0.3px',
            fontSize: 22,
            textTransform: 'none',
            fontFamily: 'var(--fuzzscan-ui-font)',
            lineHeight: 1
          }}
        >
          <span style={{ color: 'var(--pc-sidebar-main-active-color, #0f172a)' }}>Fuzz</span>
          <span style={{ color: '#22c55e' }}>Scan</span>
        </span>
        <span
          style={{
            fontSize: 9,
            fontWeight: 600,
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            color: '#22c55e',
            background: 'rgba(34, 197, 94, 0.1)',
            border: '1px solid rgba(34, 197, 94, 0.2)',
            borderRadius: 4,
            padding: '2px 6px',
            marginLeft: 'auto'
          }}
        >
          Pro
        </span>
      </Link>
    </div>
  );
};
